document.addEventListener("DOMContentLoaded", function () {

  document.querySelectorAll('[id^="dc-"]').forEach(function(section){

    const slider = section.querySelector('.swiper');

    if (!slider) return;

    const sectionId = section.id.replace('dc-', '');

    new Swiper(slider, {
      slidesPerView: 4,
      spaceBetween: 24,
      autoHeight: false,
      loop: false,
      //centeredSlides: true,
      //speed: 900,
      //grabCursor: true,
      autoplay: {
        delay: 3500,
        disableOnInteraction: false,
      },
      
      navigation: {
        nextEl: `.dc-next-${sectionId}`,
        prevEl: `.dc-prev-${sectionId}`,
      },
      breakpoints: {
        1200: { slidesPerView: 4 },
        992: { slidesPerView: 3 },
        576: { slidesPerView: 2 },
        0: { slidesPerView: 1 }
      }
    });

  });

});